import React from 'react';
import { useIntl } from 'react-intl';
import { FieldArray } from 'redux-form';
import InventoryTypeFields from './InventoryTypeFields';

const InventoryTypeForm = (props) => {
  const intl = useIntl();
  return <FieldArray name="types" component={InventoryTypeFields} />;
};

export default InventoryTypeForm;
